/**
 * 驾驶舱上次选择农场：读写 user_menu_usages.last_context（菜单码 SMART_FARM_COCKPIT）
 * 欢迎页主农场通过 loadHomePrimaryFarmId 回退读取本值，保持 farmId 上下文一致。
 */
import { getMenuLastContext, saveMenuLastContext } from '../../../api';

export const COCKPIT_MENU_CODE = 'SMART_FARM_COCKPIT';
/** 与 homePrimaryFarmPrefs 同码，写双端时共用，避免循环依赖 */
export const HOME_PRIMARY_FARM_MENU_CODE = 'HOME_PRIMARY_FARM';

/** @returns {Promise<string>} 上次农场 ID，无则空串 */
export async function loadCockpitLastFarmId() {
  try {
    const res = await getMenuLastContext(COCKPIT_MENU_CODE);
    const body = res?.data;
    if (!body?.success) return '';
    const ctx = body?.data?.lastContext;
    return ctx != null ? String(ctx).trim() : '';
  } catch {
    return '';
  }
}

/**
 * @param {string} farmId
 * @param {{ syncHome?: boolean }} [opts] 默认同时写入欢迎页主农场，保持上下文一致
 */
export function persistCockpitLastFarmId(farmId, opts = {}) {
  const id = farmId != null ? String(farmId).trim() : '';
  if (!id) return;
  const syncHome = opts.syncHome !== false;
  saveMenuLastContext(COCKPIT_MENU_CODE, id).catch(() => {
    /* 网络失败忽略，下次切换再写 */
  });
  if (syncHome) {
    saveMenuLastContext(HOME_PRIMARY_FARM_MENU_CODE, id).catch(() => {});
  }
}
